import { put } from 'libs/GrebbCommerceAPI/util';

export default async (basketId, line, quantity = 1) => {
    return await put(`/basket/${basketId}/line/${line}/quantity/${quantity}`, {});
};
